import React from 'react'
import { DadosContainer } from "../../../containers";
export default function DadosPage(props) {
    return (
        <div style={ { flexGrow: 1, display: 'flex', flexDirection: 'column'  } } className='dados-page-container'>
            <DadosContainer/>
        </div>
    )
}
